module.exports = __webpack_public_path__ + "static/media/chitchaat.efecd654.jpg";